import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11b5d100"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "contract-detail"
}
const _hoisted_2 = { class: "contract-detail-menu" }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_DescriptionList = _resolveComponent("DescriptionList")!
  const _component_DealerDetail = _resolveComponent("DealerDetail")!
  const _component_ComplexAutoModal = _resolveComponent("ComplexAutoModal")!
  const _component_RentPlan = _resolveComponent("RentPlan")!

  return (_ctx.id && _ctx.detail)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", {
            class: "local-main-link",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showRentPlan && _ctx.showRentPlan(...args)))
          }, "合同租金计划")
        ]),
        _createVNode(_component_DescriptionList, {
          title: '合同基本信息',
          data: _ctx.detail,
          list: _ctx.description,
          extraData: _ctx.extraData,
          collapse: _ctx.collapse,
          onCollapse: _ctx.onCollapseChange
        }, {
          triggerRepurchaseFlag: _withCtx(() => [
            (!_ctx.unOperate)
              ? (_openBlock(), _createBlock(_component_a_select, {
                  key: 0,
                  class: _normalizeClass(_ctx.detail.triggerRepurchaseFlag !== _ctx.originDetail.triggerRepurchaseFlag ? 'local-main-danger-select' : ''),
                  style: {"width":"100%"},
                  value: _ctx.detail.triggerRepurchaseFlag,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.detail.triggerRepurchaseFlag) = $event)),
                  "filter-option": false,
                  options: _ctx.select.options,
                  placeholder: "请选择"
                }, null, 8, ["class", "value", "options"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.detail.triggerRepurchaseFlag !== undefined ? _ctx.select.options.find(item => item.value == _ctx.detail.triggerRepurchaseFlag)?.label : ''), 1))
          ]),
          menu: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              disabled: _ctx.originDetail.guaranteeFlag === _ctx.detail.guaranteeFlag && _ctx.originDetail.guaranteeTermNum === _ctx.detail.guaranteeTermNum && _ctx.originDetail.triggerRepurchaseFlag === _ctx.detail.triggerRepurchaseFlag,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSave()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["data", "list", "extraData", "collapse", "onCollapse"]),
        _createVNode(_component_ComplexAutoModal, {
          ref: "dealer-modal",
          optionProps: { width: 880 },
          menuType: { target: 'cancel', name: '关闭' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DealerDetail, {
              id: _ctx.extraData.orgCustomerid,
              extraData: _ctx.extraData
            }, null, 8, ["id", "extraData"])
          ]),
          _: 1
        }, 512),
        _createVNode(_component_ComplexAutoModal, {
          ref: "rent-plan-modal",
          optionProps: { width: 880 },
          menuType: { target: 'cancel', name: '关闭' }
        }, {
          default: _withCtx((slotProps) => [
            _createVNode(_component_RentPlan, {
              id: _ctx.id,
              width: slotProps.width,
              height: slotProps.height
            }, null, 8, ["id", "width", "height"])
          ]),
          _: 1
        }, 512)
      ]))
    : _createCommentVNode("", true)
}